import { buildApiUrl } from '../config/api';

function normalizeImageFilename(student) {
  const img = student?.image;
  if (img == null || String(img).trim() === '') return null;
  return String(img).replace(/^\/+/, '');
}

/** Same path pattern as Student Attendance: API `/routes/thumbnail/:file` */
export function getStudentThumbnailUrl(student) {
  const name = normalizeImageFilename(student);
  if (!name) return null;
  return buildApiUrl(`/routes/thumbnail/${encodeURIComponent(name)}`);
}

/** Full-size image under `/routes/uploads/:file` (fallback if thumbnail missing) */
export function getStudentFullImageUrl(student) {
  const name = normalizeImageFilename(student);
  if (!name) return null;
  return buildApiUrl(`/routes/uploads/${encodeURIComponent(name)}`);
}
